'use client';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useContext, useEffect } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import { usePrevious } from '../../../utils/hooks/usePrevious.js';
import style from '../Carousel.module.scss.js';
import { SlideContext } from './SlideWrap.js';

const { componentTestLabel } = getTestLabels('CarouselSlide');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=7811-51539&node-type=frame&t=78j1b1D2r7OjbLWy-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Carousel/sub-components/CarouselSlide.tsx)
 *
 * @param {boolean} isVideo - (optional) Whether or not the slide contains a video.
 *   If true, the corresponding thumb will receive special styling.
 * @param {function} onSlideHide - (optional) A function to call when the slide is no longer in view.
 * @param {function} onSlideShow - (optional) A function to call when the slide comes into view.
 * @param {string} thumb - (optional) A URL to an image to use for the thumbnail navigation.
 *   If all slides within a carousel have a thumb prop, then the thumbnail navigation will be displayed.
 */
const CarouselSlide = ({ children, className, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
isVideo = false, onSlideHide, onSlideShow, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
thumb, ...otherProps }) => {
    const currentContext = useContext(SlideContext);
    const previousIsSelected = usePrevious(currentContext.isSelected);
    useEffect(() => {
        if (typeof previousIsSelected === 'undefined' ||
            typeof currentContext === 'undefined' ||
            typeof currentContext.isSelected === 'undefined' ||
            currentContext.isSelected === previousIsSelected) {
            return;
        }
        if (currentContext.isSelected) {
            onSlideShow?.();
        }
        else {
            onSlideHide?.();
        }
    }, [currentContext, onSlideHide, onSlideShow, previousIsSelected]);
    return (jsx("div", { "data-zta": componentTestLabel, className: classNames([style['z-carousel-beta-slide'], className]), ...otherProps, children: children }));
};
CarouselSlide.displayName = 'CarouselSlide';
const CarouselSlideBeta = CarouselSlide;
CarouselSlideBeta.displayName = 'CarouselSlideBeta';

export { CarouselSlide, CarouselSlideBeta };
//# sourceMappingURL=CarouselSlide.js.map
